import realTimeMonitorApi from './realTimeMonitor'
import reportsApi from './reports'
import alarmApi from './alarm'
import loginApi from './login'
import platformApi from './platform'
import operationApi from './operation'
import serverApi from './server'
import baseComponentsApi from './baseComponents'
import homeApi from './home'
import systemConfigApi from './systemConfig'
import activeSafetyApi from './activeSafety'
import taxiApi from './taxi'
import appApi from './app'
import allApi from './all'
export default {
  realTimeMonitorApi,
  reportsApi,
  alarmApi,
  loginApi,
  platformApi,
  operationApi,
  serverApi,
  baseComponentsApi,
  homeApi,
  systemConfigApi,
  activeSafetyApi,
  taxiApi,
  appApi,
  allApi
}



// WEBPACK FOOTER //
// ./src/services/api/index.js